import React, { useEffect, useState } from "react";
import "./home.scss";
import Footer from "../../components/Footer/Footer";
import Sider from "../../components/Sider/Sider";
import Navbar from "../../components/Navbar/Navbar";
import { connect } from "react-redux";
import {
  getCurrentUser,
  getProfile,
} from "../../../redux/auth/auth-operations";
import AllRoutes from "../../../routes/routes";
import { getSubscriptionInfo } from "../../../redux/subscription/subscription-operations";
import { getIsGotInfo } from "../../../redux/consultations/consultations-selectors";
import ModalWindow from "../../components/ModalWindow/ModalWindow";
import { setModalCallInfo } from "../../../redux/chat/chat-actions";
import callSound from "../../../audios/call.mp3";
import { closeFishka } from "../../../redux/fishka/fishka-actions";
import { getIsFishkaOpen } from "../../../redux/fishka/fishka-selectors";
import FishkaMain from "../../components/FishkaMain/FishkaMain";
import {
  calculateConsultationBonuses,
  calculateSubscriptionBonuses,
  getPatientBonuses,
} from "../../../redux/fishka/fishka-operations";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Callmodal } from "../../components/CallModal/CallModal";
import { RefToMobile } from "../../components/RefToMobile/RefToMobile";
import { PopupPermissions } from "../../components/PopupPermission/PopupPermission";
import BackgroundCall from "../../components/BackgroundCall/BackgroundCall";
import { connectNotification } from "../../../redux/socket/socketActions";
import { compose } from "@reduxjs/toolkit";
import { useLocation, useNavigate, withRouter } from "react-router-dom";
import TransitionModal from "../../components/Transition/Transition";
import { getIsPromocodeModalOpen } from "../../../redux/banners/banners-selectors";
import { openPromocodeModal } from "../../../redux/banners/banners-actions";
import { checkPendingDeeplink, clearPendingDeeplink } from "../../../redux/deeplink/deeplink-operations";
import { getDeeplinkData } from "../../../redux/deeplink/deeplink-selectors";
import { getUserCards } from "../../../redux/auth/auth-operations";
import { getUserCardsSelector } from "../../../redux/auth/auth-selectors";
import { createCard } from "../../../redux/cards/cards-operations";
import moment from "moment";

function Home({
  profile,
  closeFishka,
  getProfile,
  callModalInfo,
  setModalCallInfo,
  isFishkaOpen,
  getPatientBonuses,
  currentPath,
  connectNotification,
  isPromocodeModalOpen,
  openPromocodeModal,
  checkPendingDeeplink,
  deeplinkData,
  mainCard,
  userCards,
  getUserCards,
  createCard,
  clearPendingDeeplink,
}) {
  const [isShown, setIsShown] = useState(false);
  const [open, setOpen] = useState(false);
  const callAudio = React.useRef(new Audio(callSound));
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkPendingDeeplink();
  }, []);

  useEffect(() => {
    if (deeplinkData) {
      if (userCards && userCards.length > 0) {
        navigate(`/subscriptions/${userCards[0].id}`);
      } else if (profile) {
        const defaultCardData = {
          patientCard: {
            firstName: profile.firstName,
            lastName: profile.lastName,
            middleName: profile.middleName,
            birthDate: moment(profile.birthdate).format("YYYY-MM-DD"),
            relationShip: 1, // Self
            gender: profile.gender === "male" ? 0 : 1,
            isDefault: true,
          },
        };
        createCard(defaultCardData).then((newCard) => {
          if (newCard && newCard.id) {
            navigate(`/subscriptions/${newCard.id}`);
          }
        });
      }
    }
  }, [deeplinkData, userCards, profile, createCard, navigate, clearPendingDeeplink]);

  useEffect(() => {
    if (callModalInfo) {
      callAudio.current.play();
      callAudio.current.volume = 0.3;
    } else {
      callAudio.current.pause();
    }
  }, [callModalInfo]);

  useEffect(() => {
    localStorage.setItem("currentLocation", pathname);
  }, [pathname]);

  useEffect(() => {
    try {
      Notification.requestPermission((perm) => {
        if (perm === "denied") {
          setIsShown(true);
          setTimeout(() => {
            setIsShown(false);
          }, 10000);
        }
        if (perm !== "denied") {
          setIsShown(true);
          setTimeout(() => {
            setIsShown(false);
          }, 10000);
        }
        if (perm === "granted") {
          setIsShown(false);
        }
      });
      connectNotification();
    } catch (error) {
      console.error(error);
      setIsShown(false)
      connectNotification();
    }
  }, []);

  const handleCloseCallModal = () => {
    setModalCallInfo(null);
  };

  useEffect(() => {
    getProfile();
    getUserCards();
    // getPatientBonuses()
  }, []);

  useEffect(() => {
    if (profile) {
      localStorage.setItem("userId", profile.userId);
    }
  }, [profile]);

  const handleCloseFishka = () => {
    closeFishka();
  };
  
  const togglePromocodeModal = (newState) => {
    openPromocodeModal(newState);
  };

  return (
    <>
      <main>
        <div className="appWrapper">
          <div className="siderArea">
            <Sider />
          </div>
          <div className="headerArea" onClick={() => setOpen(true)}>
            <Navbar />
          </div>
          <div className="footerArea">
            <Footer />
          </div>
          <div className="contentArea">
            <AllRoutes currentPath={currentPath} />
          </div>
          <div className="sidebarArea">
            <Sidebar />
          </div>
        </div>
        <ModalWindow
          open={callModalInfo}
          handleCloseModal={handleCloseCallModal}
          confirmMode
        >
          <Callmodal />
        </ModalWindow>
        <ModalWindow
          open={isFishkaOpen}
          handleCloseModal={handleCloseFishka}
          confirmMode
        >
          <FishkaMain />
        </ModalWindow>
        {isShown && <PopupPermissions />}
      </main>
      <RefToMobile />
      <BackgroundCall />
      <TransitionModal
        isOpen={isPromocodeModalOpen}
        setOpen={togglePromocodeModal}
      ></TransitionModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user && state.user.userInfo,
  profile: state.user.profile,
  isGotInfo: getIsGotInfo(state),
  isFishkaOpen: getIsFishkaOpen(state),
  callModalInfo: state.chat?.callModalInfo,
  isPromocodeModalOpen: getIsPromocodeModalOpen(state),
  deeplinkData: getDeeplinkData(state),
  userCards: getUserCardsSelector(state),
  // isActiveCall: state?.chat?.isPeerConnected,
});

const mapDispatchToProps = {
  getCurrentUser,
  getSubscriptionInfo,
  getProfile,
  setModalCallInfo,
  closeFishka,
  getPatientBonuses,
  calculateSubscriptionBonuses,
  connectNotification,
  openPromocodeModal,
  checkPendingDeeplink,
  createCard,
  getUserCards,
  clearPendingDeeplink,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
